import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getProviderCallRatePrivileges } from 'src/app/privileges/privileges.selector';
import { CallCostPrivileges } from '../models/call-cost-privileges';
import { CallCostOrderingOptions, CallCostRegisterOptions } from '../models/call-cost-register-options';
import { CallCostRegisterListItem } from '../models/call-cost-register-results.model';
import { addProviderCallRateFile, callCostRegisterAdapterActions } from '../state/call-cost-register.actions';
import * as callCostRegisterReducer from '../state/call-cost-register.reducer';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-call-cost-register',
    templateUrl: './call-cost-register.component.html',
    standalone: false
})
export class CallCostRegisterComponent extends Register<
   CallCostRegisterListItem,
   CallCostRegisterOptions,
   CallCostOrderingOptions
> {
   columns: string[];
   entityName = 'Call Cost';
   pluralName = 'Call Costs';
   filters: string[];
   callCostPrivileges$: Observable<CallCostPrivileges>;

   constructor(public store: Store) {
      super(store, callCostRegisterReducer.selectors, callCostRegisterAdapterActions);
      this.columns = ['provider', 'code', 'destination', 'cost', 'updateDate'];
      this.callCostPrivileges$ = store.pipe(select(getProviderCallRatePrivileges));
   }

   onAddProviderFile(): void {
      this.store.dispatch(addProviderCallRateFile());
   }
}
